export class RideAnimal {
  color_code?: string;
  color_id?: number;
  color_name?: string;
  color_correct?: boolean;
  country_code?: string;
  created_at?: string;
  date_of_birth?: string;
  date_of_birth_mutation?: string;
  gender_code?: string;
  gender_id?: number;
  gender_name?: string;
  gender_correct?: boolean;
  id: PropertyKey;
  ride_id?: PropertyKey;
  identification_number?: string;
  is_healthy?: boolean;
  kvs_animal_error_code?: string;
  kvs_animal_error_message?: string;
  not_healthy_reason_code?: string;
  not_healthy_reason_id?: number;
  not_healthy_reason_name?: string;
  price?: number;
  remarks?: string;
  rvo_arrival_at?: string;
  rvo_departure_at?: string;
  work_number?: string;
  weight?: number;
  warranty?: boolean;
  is_project?: boolean;
  warranty_checked?: boolean;
  warranty_till?: string;
  ride_relation?: string;
  loading_ubn?: string;
  kvs_succes_indicator?: string;
  kvs_dummy_ride_id?: number | null;
  kvs_dummy_error?: string | null;
  ride_number?: string;
  ride_license_plate?: string;
  loaded_at?: string;

  rvo_passport_at?: string;
  rvo_export_at?: string;

  gt_36: boolean;
}
